const B2B_V2 = true

const invoiceTypes = ['增值税普通电子发票（单位）', '增值税普通电子发票（个人）']
const APP_CODE = 'xxsb'
const TIP_SHOW = true
// const invoiceTypes = ['普通电子发票（单位）', '普通电子发票（个人）', '增值税专用发票']
const title = '学习时报社在线征订系统'
const copyright = '学习时报社  版权所有'
const icp = '京ICP备17073369号-1'
const ISSUE_RANGE = false
const accountInfo = {
  name: '中央党校（国家行政学院）报刊社',
  bank: '建行北京中关村分行',
  account: '1105 0163 3600 0000 0004',
  bankNum: '',
  address: ''
}
const payWay = [
  'wechat',
  'upload'
]
const ORDER_STATE = [
  {
    label: '全部',
    state: '-1'
  },
  {
    label: '未支付',
    state: 'PN'
  },
  {
    label: '已支付',
    state: 'P1'
  },
  {
    label: '凭证审核中',
    state: 'P2'
  },
  {
    label: '提前开票审核中',
    state: 'A2'
  },
  {
    label: '未开票',
    state: 'IN'
  },
  {
    label: '已开票',
    state: 'I1'
  },
  {
    label: '订单已取消',
    state: 'I9'
  }
]
const invoiceEnable = function (order) {
  return order.subCategory !== '个人'
}

export default {
  ISSUE_RANGE: ISSUE_RANGE,
  invoiceTypes: invoiceTypes,
  title: title,
  icp: icp,
  APP_CODE: APP_CODE,
  copyright: copyright,
  accountInfo: accountInfo,
  payWay: payWay,
  ORDER_STATE: ORDER_STATE,
  invoiceEnable: invoiceEnable,
  TIP_SHOW: TIP_SHOW,
  B2B_V2: B2B_V2,
  org: {
    enabled: false,
    label: '归属区域'
  },
  invoice: {
    disabledAfter: 90 * 86400 * 1000,
    disabledAfterDesc: '订单支付超过3个月，如果未开票，订单点击开票时，弹框提示：“请您务必在消费三个月内开具电子发票，逾期请致电18010230880开票',
    requestAfterReverse: false,
    taxNumRequired: true,
    splitInvoice: false
  },
  footer: {
    customPhone: '',
    adLine: '',
    bookLine: '电话：010-68928763 ,010-68929729',
    afterSalePhone: ''
  },
  popInfo: true
}
